import { render, staticRenderFns } from "./RichTextEditorModal.vue?vue&type=template&id=7bd51e39&scoped=true"
import script from "./RichTextEditorModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./RichTextEditorModal.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./RichTextEditorModal.vue?vue&type=style&index=0&id=7bd51e39&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bd51e39",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/yogeshadhikari/Desktop/Projects/Scopic/picflow/picflow-fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7bd51e39')) {
      api.createRecord('7bd51e39', component.options)
    } else {
      api.reload('7bd51e39', component.options)
    }
    module.hot.accept("./RichTextEditorModal.vue?vue&type=template&id=7bd51e39&scoped=true", function () {
      api.rerender('7bd51e39', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/screens/screen/richTextEditor/RichTextEditorModal.vue"
export default component.exports